export default __webpack_public_path__ + "img/dgoyBNwf.59d80727.svg";